import { type FunctionComponent, type ReactNode, useId } from 'react';

export const FormField: FunctionComponent<{
    readonly children: (id: string) => ReactNode;
    readonly label: string;
}> = ({ children, label }) => {
    const id = useId();

    return (
        <div className="flex w-full min-w-0 flex-col gap-s">
            <label className="text-body-s font-medium text-text-heading" htmlFor={id}>
                {label}
            </label>
            {children(id)}
        </div>
    );
};
